import { ref } from 'vue'

// O Chrome/Edge (Android e desktop) dispara beforeinstallprompt uma vez, logo no carregamento.
// Guardamos o evento para oferecer a instalação pelo nosso próprio convite: a mini-barra
// automática do navegador aparece uma única vez e some por meses se for dispensada.
const deferredPrompt = ref(null)

// convite de instalação na tela (o PushPrompt espera ele sair para não sobrepor)
export const installOfferVisible = ref(false)

export const isStandalone = () =>
    window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true

export const canInstall = () => !!deferredPrompt.value && !isStandalone()

window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault()
    deferredPrompt.value = event
})

window.addEventListener('appinstalled', () => {
    deferredPrompt.value = null
})

/** Abre o diálogo nativo de instalação. Retorna true se o usuário aceitou. */
export const promptInstall = async () => {
    const event = deferredPrompt.value
    if (!event) return false
    // o evento só pode ser usado uma vez
    deferredPrompt.value = null
    event.prompt()
    const { outcome } = await event.userChoice
    return outcome === 'accepted'
}
